import React, { createContext,  useContext,  useEffect } from "react";

const ContextApi = createContext();

export const ContextApiProvider = ({ children }) => { 

  let activeEscapeHandlers = [];
  
  const useEscapeKey = (callback) => {
    useEffect(() => {    
      const handler = (e) => {
        if (e.key === "Escape") {         
          const isTopMost = activeEscapeHandlers[activeEscapeHandlers.length - 1] === handler;
          if (isTopMost) callback?.();
        }
      };
  
      activeEscapeHandlers.push(handler);
      window.addEventListener("keydown", handler);
  
      return () => {    
        activeEscapeHandlers = activeEscapeHandlers.filter((h) => h !== handler);
        window.removeEventListener("keydown", handler);
      };
    }, [callback]);
  };

  return (
    <ContextApi.Provider
      value={{        
        useEscapeKey,
      }}
    >
      {children}
    </ContextApi.Provider>
  );
};

export const useEscapeKeyContext = () => useContext(ContextApi);
